const VehiclesOverview = () => {
  return (
    <div className="bg-white  rounded border h-[450px]">
      <div className="flex items-center justify-between px-4 py-3 border-b">
        <h5 className="text-lg font-semibold text-gray-600">
          Vehicles overview
        </h5>
        {/* <div className="relative inline-block text-left">
          <button
            className="p-1 text-gray-600 hover:text-gray-800"
            type="button"
          >
            <i className="fa fa-bars"></i>
          </button>
          <div className="hidden absolute right-0 mt-2 w-40 bg-white border rounded shadow-md z-10">
            <a
              href="#"
              className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
            >
              Select All
            </a>
            <a
              href="#"
              className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
            >
              Refresh
            </a>
            <a
              href="#"
              className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
            >
              Share
            </a>
          </div>
        </div> */}
      </div>

      <div className="p-4">
        <div className="hidden lg:flex mb-5 text-sm font-medium">
          <div className="w-[39.7%] text-center text-green-600">On the way</div>
          <div className="w-[28.3%] text-center text-blue-600">Unloading</div>
          <div className="w-[17.4%] text-center text-cyan-600">Loading</div>
          <div className="w-[14.6%] text-center text-red-500">Waiting</div>
        </div>

        <div className="flex rounded overflow-hidden h-11 text-sm font-medium">
          <div className="bg-gray-100 text-gray-800 px-2 lg:px-4 flex items-center justify-start w-[39.7%]">
            39.7%
          </div>
          <div className="bg-blue-500 text-white px-2 lg:px-4 flex items-center justify-start w-[28.3%]">
            28.3%
          </div>
          <div className="bg-cyan-500 text-white px-2 lg:px-4 flex items-center justify-start w-[17.4%]">
            17.4%
          </div>
          <div className="bg-red-500 text-white px-2 lg:px-4 flex items-center justify-start w-[14.6%]">
            14.6%
          </div>
        </div>

        <div className="overflow-x-auto mt-4">
          <table className="w-full text-sm">
            <tbody>
              <tr className="border-b">
                <td className="w-3/4 py-3">
                  <div className="flex items-center">
                    <i className="ri ri-car-line text-gray-800 text-xl mr-2"></i>
                    <span className="font-normal">On the way</span>
                  </div>
                </td>
                <td className="text-right whitespace-nowrap">2hr 10min</td>
                <td className="text-right ps-6">39.7%</td>
              </tr>
              <tr className="border-b">
                <td className="w-3/4 py-3">
                  <div className="flex items-center">
                    <i className="ri ri-download-line text-gray-800 text-xl mr-2"></i>
                    <span className="font-normal">Unloading</span>
                  </div>
                </td>
                <td className="text-right whitespace-nowrap">3hr 15min</td>
                <td className="text-right ps-6">28.3%</td>
              </tr>
              <tr className="border-b">
                <td className="w-3/4 py-3">
                  <div className="flex items-center">
                    <i className="ri ri-upload-line text-gray-800 text-xl mr-2"></i>
                    <span className="font-normal">Loading</span>
                  </div>
                </td>
                <td className="text-right whitespace-nowrap">1hr 24min</td>
                <td className="text-right ps-6">17.4%</td>
              </tr>
              <tr>
                <td className="w-3/4 py-3">
                  <div className="flex items-center">
                    <i className="ri ri-time-line text-gray-800 text-xl mr-2"></i>
                    <span className="font-normal">Waiting</span>
                  </div>
                </td>
                <td className="text-right whitespace-nowrap">5hr 19min</td>
                <td className="text-right ps-6">14.6%</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default VehiclesOverview;
